// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"0e486938","410":"725cf349","874":"44a2835c","914":"0b590a0c","952":"173127b6","993":"bad512ae"}[chunkId] + ".chunk.css";
};